// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3XuG8","title":"InfoRow_title__k10Hp"};